import { toast } from 'react-toastify';

export const copyToClipboard = (
  text: string,
  onSuccess: () => void,
  onErrorMessage = 'Copy failed!',
) => {
  // Fallback function to improve support all browsers
  const fallbackCopy = () => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed'; // avoid scrolling
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      onSuccess();
    } catch (err) {
      toast.error(onErrorMessage, { toastId: '13' });
    }

    document.body.removeChild(textarea);
  };

  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)
      .then(onSuccess)
      .catch(() => fallbackCopy());
  } else {
    fallbackCopy();
  }
};